import React, {useEffect, useState} from "react";
import {NewBranchWarpper} from "components/atoms/Store/ManageStore/AddNewBranch/AddNewBranch.styles";
import manageStores from "services/manageSores";
import Toast from "components/molecules/Toast";
import {useSelector} from "react-redux";
import {useAuthContext} from "Context/authContext";
import StoreDetails from "./StoreDetails";
import AssignMenu from "./AssignMenu";
import ReviewStore from "./ReviewStore";

const tabs = ["Store Details", "Assign Menu", "Review & Finish"];
const editTabs = ["Store Details", "Review & Finish"];

const AddNewBranch = ({onClose, editBranch, onStoreCreated}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [formData, setFormData] = useState({
        form1: null,
        form2: null,
        form3: null,
        form4: null,
        form5: null,
    });
    const [isEditMode, setIsEditMode] = useState(false);

    // Populate form data when editing
    useEffect(() => {
        if (editBranch) {
            setIsEditMode(true);

            // Populate form1 (Store Details)
            const form1Data = {
                storeName: editBranch.name || editBranch.title || "",
                storeEmail: editBranch.store_email || "",
                address: editBranch.address || {},
                cuisines: editBranch.cuisines || [], // Use cuisines directly from editBranch
                upload_image: editBranch.store_logo,
                upload_banner: editBranch.cover_banner,
                roundtrip_business_id: editBranch.roundtrip_business_id, // Include roundtrip_business_id
                serviceType: [
                    ...(editBranch.service_types?.delivery ? [{label: 'Delivery', value: 'Delivery'}] : []),
                    ...(editBranch.service_types?.pickup ? [{label: 'Pickup', value: 'Pickup'}] : [])
                ]
            };
            
            // Populate form3 (Menu Assignment) - default to create new for edit
            const form3Data = {
                menu_action: 'create_new',
                source_store_id: null
            };
            
            setFormData({
                form1: form1Data,
                form2: null, // Business Hours removed
                form3: form3Data,
                form4: null,
                form5: null,
            });
        }
    }, [editBranch]);

    // Handle tab click for navigation in edit mode
    const handleTabClick = (tabIndex) => {
        if (isEditMode) {
            setActiveTab(tabIndex);
        }
    };
    
    // const {refetch} = useAuthContext();
    // const restaurantId = useSelector(state => state.business.businessId);

    // useEffect(() => {
    //     if (editBranch) {
    //         console.log(editBranch, 'editBranch')
    //         form.setFieldsValue({
    //             name: editBranch.name,
    //             metaTitle: editBranch.metaTitle,
    //             description: editBranch.description,
    //             address: editBranch?.address,
    //             upload_image: editBranch.store_logo,
    //         });
    //         setAddress(editBranch.address);
    //     }
    // }, [editBranch]);
    // async function handleSubmit(e) {
    //     const payload = {
    //         title: e.name,
    //         metaTitle: e.metaTitle,
    //         description: e.description || "",
    //         store_logo: e.upload_image,
    //     };
    //     const formDataToSend = new FormData();
    //     for (const [key, value] of Object.entries(payload)) {
    //         formDataToSend.append(key, value);
    //     }

    //     if (editBranch) {
    //         console.log(editBranch, 'editBranch')
    //         formDataToSend.append("restaurant", editBranch?.restaurant?._id);
    //         formDataToSend.append("address", JSON.stringify(address));
    //         setLoading(true);
    //         try {
    //             const res = await manageStores.editStore(editBranch?._id, formDataToSend);
    //             Toast({type: "success", message: res.message});
    //             refetch();
    //             onClose();
    //             setLoading(false);
    //         } catch (err) {
    //             setLoading(false);
    //             Toast({type: "error", message: err.message});
    //         }
    //     } else {
    //         console.log(restaurantId, 'restaurantId')
    //         formDataToSend.append("restaurant", restaurantId);
    //         formDataToSend.append("address", JSON.stringify(address));
    //         setLoading(true);
    //         try {
    //             const res = await manageStores.createStore(formDataToSend);
    //             Toast({type: "success", message: res.message});
    //             refetch();
    //             onClose();
    //             setLoading(false);
    //         } catch (err) {
    //             setLoading(false);
    //             Toast({type: "error", message: err.message});
    //         }
    //     }
    // }

    return (
        <>
            <NewBranchWarpper>
                <ul className="tab-wrap">
                    {(isEditMode ? editTabs : tabs)?.map((data, index) => (
                        <li 
                            key={index} 
                            className={`${activeTab >= index ? "active" : ""} ${isEditMode ? "clickable" : ""}`}
                            onClick={() => isEditMode && handleTabClick(index)}
                            style={isEditMode ? { cursor: 'pointer' } : {}}
                        >
                            {data}
                        </li>
                    ))}
                </ul>
                <span className="step-desc">
                    Step {activeTab + 1} of {isEditMode ? 2 : 3}:{" "}
                    {activeTab === 0 && "Enter your Store name, location, contact details, and service types"}
                    {!isEditMode && activeTab === 1 && "Choose to copy, duplicate, or create a new menu for this Store."}
                    {((!isEditMode && activeTab === 2) || (isEditMode && activeTab === 1)) && "Confirm all details before completing your Store setup."}
                </span>

                {activeTab === 0 && (
                    <StoreDetails 
                        formData={formData} 
                        setFormData={setFormData} 
                        setActiveTab={setActiveTab} 
                        editBranch={editBranch}
                    />
                )}
                {!isEditMode && activeTab === 1 && (
                    <AssignMenu formData={formData} setFormData={setFormData} setActiveTab={setActiveTab} />
                )}
                {((!isEditMode && activeTab === 2) || (isEditMode && activeTab === 1)) && (
                    <ReviewStore
                        formData={formData}
                        setFormData={setFormData}
                        setActiveTab={setActiveTab}
                        onClose={onClose}
                        editBranch={editBranch}
                        isEditMode={isEditMode}
                        onStoreCreated={onStoreCreated}
                    />
                )}
            </NewBranchWarpper>
        </>
    );
};

export default AddNewBranch;
